export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7336.28833873.jpg";